/**
 * TURBO MOTO 84 — cartridge palette.
 *
 * Dirt-track motocross filtered through the cabinet's vaporwave-CRT look.
 * The signature read is HEAT: a temperature gauge that climbs cool-cyan →
 * amber → redline as the rider holds boost. The track is a warm clay
 * ribbon under a bruised-sunset sky; the rider pops hot-orange so it's
 * always findable against the churn. Rival bikes are a cooler magenta so
 * "that's not me" reads instantly.
 */

// ---- Sky / backdrop ----
export const SKY_TOP = '#2a1038';        // bruised violet up high
export const SKY_BOTTOM = '#5a1e2a';     // dusty sunset red at the horizon
export const SUN = '#ff9a3d';            // low amber sun disc
export const HILL_FAR = '#3a1630';       // far parallax ridge
export const HILL_NEAR = '#26102a';      // near parallax ridge

// ---- Track ----
// A clay ribbon split into horizontal lanes. Lane separators are faint
// so they guide without fighting the action; the rumble edges glow.
export const TRACK_BASE = '#4a2a1a';     // packed clay
export const TRACK_DARK = '#331d12';     // shadowed lane band (alternating)
export const LANE_LINE = '#6a4028';      // faint lane separator
export const TRACK_EDGE = '#29e6ff';     // cyan rumble-strip glow (top/bottom)
export const TRACK_STRIPE = '#ffd23d';   // dashed center hazard stripe

// ---- Ramps + obstacles ----
export const RAMP_FACE = '#7a4a24';      // lit ramp face
export const RAMP_EDGE = '#ffd23d';      // gold takeoff lip
export const MUD = '#2a1a10';            // mud patch (slows you)
export const ROCK = '#8a6a58';           // rock obstacle body
export const ROCK_DARK = '#4a382e';      // rock shadow

// ---- Player rider ----
export const RIDER_BODY = '#ff8030';     // hot-orange bike + rider
export const RIDER_DARK = '#a04010';     // frame shadow
export const RIDER_HELMET = '#ffd23d';   // gold helmet dome
export const RIDER_WHEEL = '#1a1015';    // tyres
export const RIDER_TRAIL = '#ff3d9a';    // motion trail while boosting

// ---- Rival riders ----
export const RIVAL_BODY = '#ff3088';     // magenta — "not you"
export const RIVAL_DARK = '#8a1850';
export const RIVAL_HELMET = '#a0fff0';

// ---- Heat gauge (the signature mechanic) ----
// Cool → warm → redline. The bar frame is neutral; the fill sweeps hue
// with temperature so the player reads danger without a number.
export const HEAT_COOL = '#29e6ff';      // low temp
export const HEAT_WARM = '#ffd23d';      // mid temp
export const HEAT_HOT = '#ff6020';       // high temp
export const HEAT_REDLINE = '#ff3030';   // over the line — stall imminent
export const HEAT_FRAME = '#7af3c8';     // gauge outline / label

// ---- HUD ----
export const HUD_LABEL = '#7af3c8';      // cyan labels, cabinet default
export const HUD_SCORE = '#ffea00';      // gold score numerals
export const HUD_SPEED = '#29e6ff';      // speed readout
export const HUD_DIST = '#a0fff0';       // pale-cyan distance

// ---- Cards (crash / start) ----
export const CARD_BG = '#2a1038';        // sky-colored backdrop
export const CARD_BORDER = '#ff3030';    // red border = wipeout
export const CARD_TEXT = '#ffea00';      // gold heading
export const CARD_SUB = '#ff80a0';       // pale-pink subtitle
export const CRASH_FLASH = '#ff3030';    // full-screen hit flash

// ---- Attract chrome ----
export const ATTRACT_TITLE = '#ff8030';  // rider-orange wordmark
export const ATTRACT_PROMPT = '#7af3c8'; // cyan "PRESS START"

/**
 * Tokens the cabinet samples for marquee tinting while this cartridge is
 * loaded. First entry is the single "this is the cartridge's color" pick.
 */
export const PALETTE_HINT: readonly string[] = [
  RIDER_BODY,   // rider orange — the cartridge's signature
  HEAT_HOT,     // heat-gauge red-orange
  TRACK_EDGE,   // cyan rumble glow
  CARD_BG,      // bruised-violet sky
];
